export const Scanlines = () => {
	return (
		<div
			class={`pointer-events-none absolute inset-0 animate-scanlines`}
			style={{
				opacity: 0.75,
				background: `repeating-linear-gradient(transparent 0px, rgba(0, 255, 102, 0.1) 1px, transparent 2px, transparent 2px)`,
				'will-change': 'background-position',
			}}
		/>
	);
};
